import { PStyled } from 'approot/shared/styles/typography.style';
import { ActivityBuilderModal } from '../activity-builder-modal';

const ActivitiesPublishPermissionWarning = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  return (
    <ActivityBuilderModal
      isVisible
      title="Publish"
      headerTitle="Publish"
      onClose={onClose}
    >
      <PStyled>
        <strong>You do not have permission to publish these activities.</strong>
      </PStyled>
      <PStyled marginBottom={0}>
        Only users with the role Activity Publisher can complete this action.
      </PStyled>
    </ActivityBuilderModal>
  );
};

export default ActivitiesPublishPermissionWarning;
